import { inject } from '@angular/core';
import { CanActivateFn, RedirectCommand, Router } from '@angular/router';

export const redirectTo404: CanActivateFn = (): RedirectCommand =>
	new RedirectCommand(inject(Router).parseUrl('/404'), { skipLocationChange: true });
